import { render, staticRenderFns } from "./moreButton.vue?vue&type=template&id=28769a12&scoped=true"
import script from "./moreButton.vue?vue&type=script&lang=js"
export * from "./moreButton.vue?vue&type=script&lang=js"
import style0 from "./moreButton.vue?vue&type=style&index=0&id=28769a12&prod&lang=css"
import style1 from "./moreButton.vue?vue&type=style&index=1&id=28769a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28769a12",
  null
  
)

export default component.exports